import { render, staticRenderFns } from "./EventDetailPage.vue?vue&type=template&id=51fa77a7"
import script from "./EventDetailPage.vue?vue&type=script&lang=js"
export * from "./EventDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports